<input 
  #timeInput
  class="full-width inputcustom time-picker-input"
  [class.error-state]="hasError"
  type="text" 
  [placeholder]="placeholder"
  readonly
/>